<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          categories = data?.metaData?.categories || []
          this.isLoading = false
        }
      "
      contentId="categories"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Catégories</div>
      <div>
        <button
          class="buttonComponent px-6 py-3"
          @click="addCategory"
          v-if="categories.length > 0"
        >
          + Catégorie
        </button>
      </div>
    </div>
    <div class="py-2"></div>
    <div
      class="h-[calc(100%-8rem)] overflow-auto w-full"
      ref="container"
      v-if="isLoading || categories.length > 0"
    >
      <div class="grid grid-cols-3 gap-0 h-full w-[300%] md:w-full">
        <div class="rounded-2xl bg-white shadow-xl h-full overflow-hidden py-4">
          <div class="h-full overflow-auto flex flex-col gap-1">
            <div v-for="(category, i) in categories" :key="i">
              <div
                class="flex w-full justify-between gap-12 items-center cursor-pointer px-4 py-2"
                @mouseenter="selectCategoryToEdit(category)"
                :class="{
                  'bg-slate-100': categoryToEdit.id === category.id,
                }"
              >
                <div>
                  {{ category.name }}
                </div>
                <div
                  class="w-2 h-2 border-r border-t rotate-45 border-primary duration-300"
                  :class="{
                    '-translate-x-full opacity-10':
                      categoryToEdit.id !== category.id,
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="categoryToEdit?.id"
          class="flex flex-col gap-2 h-full overflow-auto"
        >
          <div class="px-4">
            <div class="flex flex-col gap-2 rounded-2xl bg-white shadow-xl p-4">
              <div class="flex gap-2 items-center">
                <div
                  class="w-16 h-16 min-w-16 border rounded-lg overflow-hidden"
                >
                  <img
                    :src="categoryToEdit.imageUrl"
                    :key="categoryToEdit.imageUrl"
                    class="w-full h-full object-cover"
                    alt=""
                  />
                </div>
                <div>
                  <div class="title-color">
                    {{ categoryToEdit.name }}
                  </div>
                  <div class="pt-1"></div>
                  <div>
                    <button
                      @click="addSubcategory"
                      class="buttonComponent bg-transparent text-primary !px-0 pr-0 py-0 arrow text-sm"
                    >
                      Nouvelle sous categorie
                    </button>
                  </div>
                  <!-- {{ categoryToEdit }} -->
                </div>
                <div class="ml-auto">
                  <button class="w-6 h-6 ripple" @click="editCategory">
                    <img
                      class="w-full h-full"
                      src="@/assets/images/all/pen.svg"
                      alt=""
                    />
                  </button>
                  <div class="pt-2"></div>
                  <button class="w-6 h-6 ripple" @click="deleteCategory">
                    <img
                      class="w-full h-full"
                      src="@/assets/images/all/close.svg"
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="overflow-auto px-4 h-full">
            <div
              class="rounded-2xl bg-white shadow-xl h-full overflow-auto py-4"
            >
              <div class="flex flex-col gap-1 h-full overflow-auto">
                <div
                  v-for="(category, i) in categoryToEdit?.subcategories"
                  :key="i"
                  @mouseenter="selectSubCategoryToEdit(category)"
                >
                  <div
                    class="flex w-full justify-between gap-12 items-center cursor-pointer px-4 py-2"
                    :class="{
                      'bg-slate-100': subcategoryToEdit.id === category.id,
                    }"
                  >
                    <div>
                      {{ category.name }}
                    </div>
                    <div
                      class="w-2 h-2 border-r border-t rotate-45 border-primary duration-300"
                      :class="{
                        '-translate-x-full opacity-10':
                          subcategoryToEdit.id !== category.id,
                      }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="subcategoryToEdit?.id"
          class="flex flex-col gap-2 rounded-2xl bg-white shadow-xl p-4 h-full overflow-auto"
        >
          <div class="flex gap-4 items-center">
            <div class="text-lg">Sous Catégories</div>
            <div class="ml-auto"></div>
            <button class="w-6 h-6 ripple" @click="editSubcategory">
              <img
                class="w-full h-full"
                src="@/assets/images/all/pen.svg"
                alt=""
              />
            </button>
            <button class="w-6 h-6 ripple" @click="deleteSubcategory">
              <img
                class="w-full h-full"
                src="@/assets/images/all/close.svg"
                alt=""
              />
            </button>
          </div>
          <InputComponent
            disabled
            label="Groupe"
            v-model="subcategoryToEdit.groupName"
          />
          <InputComponent
            disabled
            label="Nom "
            v-model="subcategoryToEdit.name"
          />
          <!-- {{ subcategoryToEdit }} -->
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/application.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">Aucune catégorie</div>
        <div class="py-1"></div>
        <div class="text-lg">Les membre de votre équipes s'affichent ici</div>
        <div class="py-2"></div>
        <div class="flex justify-center">
          <button
            class="buttonComponent"
            @click="addCategory"
          >
            Créer une catégorie
          </button>
        </div>
      </div>
    </div>
    <!-- {{ categories }} -->
    <EventListener
      :events="['categories_saved', 'failed_to_save_categories']"
      @categories_saved="onInfoSaved"
      @failed_to_save_categories="onFailedToSave"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import InputComponent from '@/components/utils/InputComponent.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    InputComponent,
    EventListener,
  },
  data() {
    return {
      categories: {},
      updatedData: {},
      isLoading: true,
      haveUpdate: false,
      categoryToEdit: {},
      categoryGroupToEdit: {},
      subcategoryToEdit: {},
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    selectCategoryToEdit(category) {
      this.categoryToEdit = category
      this.categoryGroupToEdit = {}
      this.subcategoryToEdit = {}
      this.$refs.container.scrollTo(this.$refs.container.offsetWidth, 0)
    },
    selectCategoryGroupToEdit(category) {
      this.categoryGroupToEdit = category
      this.subcategoryToEdit = {}
    },
    selectSubCategoryToEdit(category) {
      this.subcategoryToEdit = category
      this.$refs.container.scrollTo(this.$refs.container.offsetWidth * 2, 0)
    },
    async addCategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Ajouter une nouvelle catégorie`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Nom',
              propertyName: 'name',
              defaultValue: '',
              required: true,
              class: '',
            },
            {
              type: 'file',
              propertyName: 'imageUrl',
              label: 'Image illustrative',
              defaultValue: '',
              class: '',
              // alreadyExistPlaceHolder: 'Choisir une autre image',
              inputProps: {
                acceptedFilesTypes: ['image/png', 'image/jpeg'],
              },
              required: true,
            },
          ],
          successText: 'Ajouter',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('new_category_available', {
        name: prompt.data.name,
        imageUrl: prompt.data.imageUrl,
      })
      this.$Events.dispatchEvent('toast_notification', {
        // title: 'Sauvegarde en cours',
        body: 'Création en cours',
      })
    },
    async editCategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Editer la catégorie`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Nom',
              propertyName: 'name',
              defaultValue: this.categoryToEdit.name,
              required: true,
              class: '',
            },
            {
              type: 'file',
              propertyName: 'imageUrl',
              label: 'Image illustrative',
              defaultValue: this.categoryToEdit.imageUrl,
              class: '',
              alreadyExistPlaceHolder: 'Choisir une autre image',
              inputProps: {
                acceptedFilesTypes: ['image/png', 'image/jpeg'],
              },
              required: true,
            },
          ],
          successText: 'Enrégistrer',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('category_update_available', {
        ...this.categoryToEdit,
        name: prompt.data.name,
        imageUrl: prompt.data.imageUrl,
      })
      this.$Events.dispatchEvent('toast_notification', {
        // title: 'Sauvegarde en cours',
        body: 'Sauvegarde en cours',
      })
    },
    async deleteCategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment supprimer la catégorie ${this.categoryToEdit.name}`,
          subTitle: `Toutes les sous-catégories de  ${this.categoryToEdit.name} seront effacées. Les produits qui y sont liés seront toujours disponible`,

          successText: 'Supprimer',
          cancelText: 'Conserver',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('category_deletion_requested', {
        id: this.categoryToEdit.id,
      })
      this.$Events.dispatchEvent('toast_notification', {
        // title: 'Sauvegarde en cours',
        body: 'Supression en cours',
      })
    },
    async addSubcategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Ajouter une sous-catégorie`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Groupe',
              propertyName: 'groupName',
              defaultValue: '',
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Nom',
              propertyName: 'name',
              defaultValue: '',
              required: true,
              class: '',
            },
          ],
          successText: 'Ajouter',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.updateSubcategory({
        groupName: prompt.data.groupName,
        name: prompt.data.name,
      })
    },
    async editSubcategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Editer la sous-catégorie`,
          // subTitle: `Vous disposez de ${this.walletInfo.balance} FCFA<br/><br/><span class="text-lg font-bold">Détails du compte </span> <br/>Numéro du compte: ${account.metadata?.accountId} <br/> Nom de la banque: ${account.metadata?.bankName} <br/> Code de banque: ${account.metadata?.bankCode} <br/> Code Guichet: ${account.metadata?.boxCode}`,
          formFields: [
            {
              type: 'text',
              label: 'Groupe',
              propertyName: 'groupName',
              defaultValue: this.subcategoryToEdit.groupName,
              required: true,
              class: '',
            },
            {
              type: 'text',
              label: 'Nom',
              propertyName: 'name',
              defaultValue: this.subcategoryToEdit.name,
              required: true,
              class: '',
            },
          ],
          successText: 'Enrégistrer',
          cancelText: 'Annuler',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.updateSubcategory({
        ...this.subcategoryToEdit,
        groupName: prompt.data.groupName,
        name: prompt.data.name,
      })
    },
    async deleteSubcategory() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment supprimer la sous-catégorie ${this.subcategoryToEdit.name}`,
          subTitle: `Les produits liés à  ${this.categoryToEdit.name} seront toujours disponible`,

          successText: 'Supprimer',
          cancelText: 'Conserver',
        },
        9999999999,
      )
      if (!prompt.accepted) return null

      this.updateSubcategory({
        id: this.subcategoryToEdit.id,
      })
    },
    updateSubcategory(subcategory) {
      let subcategoriesToSave = this.categoryToEdit.subcategories || []
      if (!subcategory.id) subcategoriesToSave.push(subcategory)
      else if (!subcategory.name) {
        subcategoriesToSave = subcategoriesToSave.filter(
          sub => sub.id !== subcategory.id,
        )
      } else
        subcategoriesToSave = subcategoriesToSave.map(sub => {
          if (sub.id !== subcategory.id) return sub
          return subcategory
        })
      this.$Events.dispatchEvent('subcategories_update_available', {
        categoryId: this.categoryToEdit.id,
        subcategories: subcategoriesToSave,
      })
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Opération en cours',
      })
    },
    saveData() {
      this.$Events.dispatchEvent(
        'categories_update_available',
        this.updatedData,
      )
    },
    onInfoSaved() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Categories enrégistrées correctement',
        body: 'Les categories ont été enrégistrées avec succès',
      })
    },
    onFailedToSave() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echec de sauvegarde',
        body: 'Désolé, les données ne sont pas enrégistrée, veuillez réessayer',
      })
    },
    availabilityDisplay(data) {
      return data
    },
  },
  watch: {
    categories(newVal) {
      this.categoryToEdit =
        newVal.find(category => category.id == this.categoryToEdit.id) || {}
      this.subcategoryToEdit =
        this.categoryToEdit.subcategories?.find(
          sub => sub.id == this.subcategoryToEdit.id,
        ) || {}
    },
  },
  computed: {
    // haveUpdate() {
    //   return JSON.stringify(this.categories) !== JSON.stringify(this.updatedData)
    // },
  },
}
</script>
